import { Component, OnInit } from '@angular/core';
import { HeaderBreadcrumbService } from 'src/app/components/header-components/header-breadcrumb/header-breadcrumb.service';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';

@Component({
  selector: 'app-broadcastings-new-broadcasting-dashboard',
  templateUrl: './broadcastings-new-broadcasting-dashboard.component.html',
  styleUrls: ['./broadcastings-new-broadcasting-dashboard.component.scss']
})
export class BroadcastingsNewBroadcastingDashboardComponent implements OnInit {

  constructor(private headerBreadcrumbService: HeaderBreadcrumbService) { }

  ngOnInit() {
    this.setBreadcrumb();
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-photo-video', 'broadcastings-page.new broadcasting', '/broadcastings/broadcastings', [new BRoute('broadcastings-page.broadcastings', '/broadcastings'), new BRoute('broadcastings-page.broadcastings', '/broadcastings/broadcastings'), new BRoute('broadcastings-page.new broadcasting')]));
  }
}
